(ns app.new-workspace.views
  (:require [app.components.buttons.views :as buttons]
            [app.components.headers.views :refer [header]]
            [app.components.input-field.views :refer [input-field]]
            [app.events :as events]
            [app.new-workspace.events :as wevents]
            [app.new-workspace.subs :as wsubs]
            [app.routes :as routes]
            [app.styles :refer [app-bar create-workspace-space
                                create-workspace-title new-workspace-container]]
            [re-com.core :as re-com :refer [at box h-box label title v-box]]
            [re-frame.core :as re-frame]
            [re-posh.core :as re-posh]
            [reagent.core  :as reagent :refer [atom]]))


(defn workspace-app-bar []
  [h-box
   :class (app-bar)
   :src   (at)
   :children [[box
               :size "50%"
               :child [buttons/button {:action :cta :type :secondary :title "cancel" :size :medium :onClick  #(re-frame/dispatch [::events/navigate [:dashboard]])}]]
              [box
               :justify :center
               :child [label :label "create new workspace"]]
              [box
               :size "50%"
               :child [:div]]]])



(defn new-workspace-panel []
  (let [text-val (reagent/atom nil)]
    [v-box
     :src      (at)
     :height "100vh"
     :children [[workspace-app-bar]
                [box
                 :size "auto"
                 :justify :center
                 :align :center
                 :align-self :center
                 :width "50%"
                 :child [v-box
                         :src (at)
                         :width "100%"
                         :class (new-workspace-container)
                         :justify :center
                         :align :center
                         :children [[title :label "Create a new workpace" :class (create-workspace-title)]
                                    [title :style  {:width "492px"}
                                     :class (create-workspace-space)
                                     :label "A workspace is where you and your team can create and collaborate on projects. Give it a nice name. (You can always change it later.)"]
                                    [input-field {:placeholder "My workspace" :disable false :value text-val
                                                  :onChange  #(reset! text-val %)
                                                  :width "448px"}]
                                    [title
                                     :class (create-workspace-space)
                                     :label "Hint: Most people use the name of their team or organization."]
                                    [buttons/button {:action :cta :type :primary
                                                     :title "Create workspace" :size :medium
                                                     :onClick #(re-posh/dispatch [::wevents/add-new-workspace @text-val])}]]]]]]))



(defmethod routes/panels :new-workspace-panel [] [new-workspace-panel])